<template>
    <div>
        <el-dialog
            title="面单"
            :visible.sync="isVisible"
            append-to-body
            width="1500px"
            top="1vh"
        >
            <div class="table_container" ref="expressSheet">
                <img
                    class="table_form"
                    :src="require('@/assets/img/form_new1.jpg')"
                    alt=""
                />
                <div class="table_content">
                    <div class="qrcode">
                        <div class="qrcode_item">
                            
                            <img :src="require('@/assets/official_account_dingyue.jpg')" alt="">
                        </div>
                        <div class="qrcode_item">
                            <img :src="qrcode" alt="">
                        </div>
                    </div>
                    <!-- 第一行 -->
                    <div class="header">
                        <div class="header_item">
                            <!-- {{ this.rowData.transportTypeSpan }} -->
                            汽运
                        </div>
                        <div class="header_item">
                            {{ this.rowData.originatingStation }}
                        </div>
                        <div class="header_item">
                            {{ this.rowData.arriveStation }}
                        </div>
                    </div>
                    <!-- 运单号 -->
                    <div class="order_number">
                        <span>{{ this.form.orderNo }}</span>
                    </div>
                    <!-- 左侧 -->
                    <div class="content_box">
                        <div class="content_left">
                            <!-- 托运人信息 -->
                            <div class="consigner">
                                <div class="consigner_item">
                                    {{ this.rowData.senderName }}
                                </div>
                                <div class="consigner_item">
                                    {{ this.rowData.senderCompanyName }}
                                </div>
                            </div>
                            <div class="consigner">
                                <div class="consigner_item">
                                    {{ this.rowData.senderTel }}
                                </div>
                                <div class="consigner_item">
                                    {{ this.rowData.senderFixed }}
                                </div>
                            </div>
                            <!-- 详细地址 -->
                            <div class="address_box">
                                <div class="address_list">
                                    <div class="address_item">
                                        <!-- {{ this.rowData.senderCodeSPan }} -->
                                        {{ this.rowData.senderProvinceSpan }} {{ this.rowData.senderAreaSpan }} {{ this.rowData.senderCitySpan }}
                                    </div>
                                </div>
                                <div class="address_info">
                                    {{ this.rowData.senderAddress }}
                                </div>
                            </div>
                            <!-- 收货人信息 -->
                            <div
                                class="consigner"
                                style="margin-bottom: 24px; padding-top: 5px"
                            >
                                <div class="consigner_item">
                                    {{ this.rowData.receiverName }}
                                </div>
                                <div class="consigner_item">
                                    {{ this.rowData.receiverCompanyName }}
                                </div>
                            </div>
                            <div class="consigner" style="margin-bottom: 15px">
                                <div class="consigner_item">
                                    {{ this.rowData.receiverTel }}
                                </div>
                                <div class="consigner_item">
                                    {{ this.rowData.receiverFixed }}
                                </div>
                            </div>
                            <div class="address_box">
                                <div class="address_list">
                                    <div class="address_item">
                                        <!-- {{ this.rowData.receiverCodeSPan }} -->
                                        {{ this.rowData.receiverProvinceSpan }} {{ this.rowData.receiverAreaSpan }} {{ this.rowData.receiverCitySpan }}
                                    </div>
                                </div>
                                <div class="address_info">
                                    {{ this.rowData.receiverAddress }}
                                </div>
                            </div>
                            <!-- 备注 -->
                            <div class="remark">
                                {{ this.rowData.pickUpGoodsRemark }}
                            </div>
                        </div>
                        <div class="content_right">
                            <!-- 货物信息 -->
                            <div class="freight">
                                <div class="freight_item">
                                    <span>{{ this.rowData.name }}</span>
                                </div>
                                <div class="freight_item">
                                    <span>{{ this.rowData.qty }}</span>
                                </div>
                                <div class="freight_item">
                                    <span>{{ this.rowData.packaging }}</span>
                                </div>
                                <div class="freight_item">
                                    <span>{{ this.rowData.volumeRel }}</span> 方
                                </div>
                                <div class="freight_item">
                                    <span>{{ this.rowData.weightRel }}</span
                                    >Kg
                                </div>
                            </div>
                            <!-- 费用信息 -->
                            <div class="expense">
                                <div class="expense_item"></div>
                                <div class="expense_item">
                                    {{ this.rowData.dropOffCharge }}
                                </div>
                                <div class="expense_item"></div>
                            </div>
                            <div class="expense" style="padding-top: 18px">
                                <div class="expense_item">
                                    {{ this.rowData.totalPriceRel }}
                                </div>
                                <div class="expense_item">
                                    {{ this.rowData.deliveryCharge }}
                                </div>
                                <div class="expense_item"></div>
                            </div>
                            <!-- 付款方式 -->
                            <div
                                class="expense"
                                style="padding-top: 54px; padding-left: 147px"
                            >
                                <div
                                    class="expense_item"
                                    style="padding-left: 40px"
                                >
                                    {{ this.rowData.hdfAmount }}
                                </div>
                                <div
                                    class="expense_item"
                                    style="padding-left: 30px"
                                >
                                    {{ this.rowData.arriveAmount }}
                                </div>
                                <div
                                    class="expense_item"
                                    style="padding-left: 40px"
                                >
                                    <!-- {{ this.rowData.amountCollected }} -->
                                </div>
                            </div>
                            <div
                                class="expense"
                                style="padding-top: 13px; padding-left: 147px"
                            >
                                <div
                                    class="expense_item"
                                    style="
                                        padding-left: 40px;
                                        width: 150px;
                                        margin-right: 78px;
                                    "
                                ></div>
                                <div
                                    class="expense_item"
                                    style="padding-left: 30px"
                                >
                                    {{ this.rowData.cashAmount }}
                                </div>
                                <div
                                    class="expense_item"
                                    style="padding-left: 0px"
                                >
                                    {{  this.rowData.payTypeSpan }}
                                </div>
                            </div>
                            <!-- 大写费用 -->
                            <div class="capital">
                                <div class="capital_left">
                                    <div class="capital_item">{{this.changeNumToHan(Number(this.rowData.totalPriceRel || 0) + Number(this.rowData.deliveryCharge || 0) + Number(this.rowData.dropOffCharge || 0))}}</div>
                                    <div class="capital_item">{{this.changeNumToHan(this.rowData.amountCollected || 0)}}</div>
                                </div>
                                <div class="capital_right">
                                    <div class="capital_number">{{Number(this.rowData.totalPriceRel || 0) + Number(this.rowData.deliveryCharge || 0) + Number(this.rowData.dropOffCharge || 0)}}</div>
                                    <div class="capital_number">{{this.rowData.amountCollected || 0}}</div>
                                </div>
                                <!-- intToChinese -->
                            </div>
                            <!-- 提货方式 回单要求 -->
                            <div class="pick">
                                <div class="pick_item">{{this.rowData.deliveryTypeSpan}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDataScope">取 消</el-button>
                <el-button @click="setCanvans" type="primary">生成图片</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    detail,
    getQrcode
} from "@/api/order";
import html2canvas from "html2canvas";
export default {
    name: "liveManageView",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: "add",
        },
    },
    computed: {
        isVisible: {
            get() {
                return this.visible;
            },
            set() {
                this.cancelDataScope();
            },
        },
        title() {
            return this.type == "add" ? "添加" : "编辑";
        },
    },
    data() {
        return {
            form: {
                image: null,
            },
            rowData: {},
            selectImg: null,
            skipList: [],
            qrcode:""
            // 表单校验
            // rules: {
            //     image: [
            //     { required: true, message: "图片不能为空", trigger: "blur" }
            //     ],
            // }
        };
    },
    methods: {
        // 关闭弹窗
        close() {
            this.$emit("close");
        },
        // 关闭后重置表单数据
        reset() {
            this.$refs["form"].clearValidate();
            this.$refs["form"].resetFields();
        },
        // 表单提交验证
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    console.log(this.form);
                }
            });
        },
        setSubmit() {
            if (this.type == "add") {
                this.save();
            } else {
                this.editForm();
            }
        },
        saveForm() {},
        editForm() {},
        cancelDataScope() {
            // this.reset();
            this.close();
        },
        setData(val) {
            console.log(val);
            this.editLoading = true;
            this.rowData = val;
            detail({ id: val.id })
                .then((response) => {
                    this.editLoading = false;
                    if (response.code == 200) {
                        console.log(response.data);
                        this.rowData = response.data;
                        console.log(this.rowData)
                        this.$set(this, "form", response.data);
                        // this.form = response.data;
                        // this.$set(this.form,'selectSenderAera',[this.form.senderProvince,this.form.senderArea,this.form.senderCity]);
                        // this.$set(this.form,'selectReceiverAera',[this.form.receiverProvince,this.form.receiverArea,this.form.receiverCity]);
                        // this.form.date = [this.form.beginTime,this.form.endTime];
                        // this.$set(this.form,'date',[this.form.beginTime,this.form.endTime])
                        // this.form.image = response.data.url;
                        this.getcqrCode(response.data.id)
                    }
                })
                .catch(() => {
                    this.editLoading = false;
                });
        },
        upload(val) {
            // this.form.image = val;
            // this.$refs.form.validateField('image');
        },
        setCanvans(val) {
            html2canvas(this.$refs.expressSheet).then((canvas) => {
                console.log(canvas);
                let url = canvas.toDataURL("image/png");
                let aLink = document.createElement("a");
                aLink.style.display = "none";
                aLink.href = url;
                const creatDom = document.createElement("a");
                document.body.appendChild(creatDom);
                creatDom.href = url;
                creatDom.download = `运单面单_${this.form.orderNo}`;
                creatDom.click();
                // window.localStorage.setItem("src", aLink.href);
            });
        },
        downloadIamge(imgsrc, name) {
            //下载图片地址和图片名
            var image = new Image();
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                var context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, image.width, image.height);
                var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

                var a = document.createElement("a"); // 生成一个a元素
                var event = new MouseEvent("click"); // 创建一个单击事件
                a.download = name || "photo"; // 设置图片名称
                a.href = url; // 将生成的URL设置为a.href属性
                a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = imgsrc;
        },
        intToChinese(str) {
            str = str + "";
            var len = str.length - 1;
            var idxs = [
                "",
                "十",
                "百",
                "千",
                "万",
                "十",
                "百",
                "千",
                "亿",
                "十",
                "百",
                "千",
                "万",
                "十",
                "百",
                "千",
                "亿",
            ];
            var num = [
                "零",
                "壹",
                "贰",
                "叁",
                "肆",
                "伍",
                "陆",
                "柒",
                "捌",
                "玖",
            ];
            return str.replace(/([1-9]|0+)/g, function ($, $1, idx, full) {
                var pos = 0;
                if ($1[0] != "0") {
                    pos = len - idx;
                    if (idx == 0 && $1[0] == 1 && idxs[len - idx] == "十") {
                        return idxs[len - idx];
                    }
                    return num[$1[0]];
                } else {
                    var left = len - idx;
                    var right = len - idx + $1.length;
                    if (Math.floor(right / 4) - Math.floor(left / 4) > 0) {
                        pos = left - (left % 4);
                    }
                    if (pos) {
                        return idxs[pos] + num[$1[0]];
                    } else if (idx + $1.length >= len) {
                        return "";
                    } else {
                        return num[$1[0]];
                    }
                }
            });
        },
            changeNumToHan(num) {
            var arr1 = ["零",
                "壹",
                "贰",
                "叁",
                "肆",
                "伍",
                "陆",
                "柒",
                "捌",
                "玖",]
            var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
            if (!num || isNaN(num)) return '零'
            var english = num.toString().split('')
            var result = ''
            for (var i = 0; i < english.length; i++) {
                var des_i = english.length - 1 - i// 倒序排列设值
                result = result
                var arr1_index = english[des_i]
                result = arr1[arr1_index] + result
            }
            // result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十') // 将【零千、零百】换成【零】 【十零】换成【十】
            // result = result.replace(/零+/g, '零') // 合并中间多个零为一个零
            // result = result.replace(/零亿/g, '亿').replace(/零万/g, '万') // 将【零亿】换成【亿】【零万】换成【万】
            // result = result.replace(/亿万/g, '亿') // 将【亿万】换成【亿】
            // result = result.replace(/零+$/, '') // 移除末尾的零
            // 将【一十】换成【十】
            result = result.replace(/^一十/g, '十')
            return result
            },

        getcqrCode(id){
            getQrcode({page:'subpages/orderDetail/index',scene:'id='+id}).then(response => {
                let url = URL.createObjectURL(response);
                // console.log(response)
                this.qrcode = url;
            })
        }
    },
};
</script>

<style lang="scss" scoped>
.table_container {
    position: relative;
    .table_form {
        width: 1481px;
        height: 952px;
        position: relative;
        z-index: 1;
    }
    .table_content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        // height: 100%;
        z-index: 2;
        .qrcode{
            display: flex;
            align-items: center;
            position:absolute;
            left: 575px;
            top: 10px;
            .qrcode_item{
                width: 150px;
                height: 150px;
                margin-right: 20px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .header {
            display: flex;
            justify-content: flex-end;
            padding-top: 90px;
            box-sizing: border-box;
            padding-right: 46px;

            .header_item {
                width: 150px;
                height: 40px;
                font-size: 24px;
                color: red;
                font-weight: bold;
                margin-right: 5px;
                text-align: center;
            }
            .header_item:last-child {
                margin-right: 0;
            }
        }

        .order_number {
            padding-top: 40px;
            font-size: 28px;
            color: red;
            font-weight: bold;
            display: flex;
            justify-content: flex-end;
            box-sizing: border-box;
            padding-right: 280px;
            margin-bottom: 11px;
        }
        .content_box {
            display: flex;
            .content_left {
                width: 725px;
                padding-top: 20px;
                .consigner {
                    display: flex;
                    justify-content: space-between;
                    font-size: 18px;
                    color: red;
                    font-weight: bold;
                    box-sizing: border-box;
                    padding-left: 120px;
                    margin-bottom: 20px;
                    .consigner_item {
                        width: 250px;
                        margin-right: 120px;
                    }
                    .consigner_item:last-child {
                        margin-right: 0;
                    }
                }

                .address_box {
                    font-size: 18px;
                    color: red;
                    font-weight: bold;
                    padding-left: 120px;
                    box-sizing: border-box;
                    margin-bottom: 54px;
                    .address_list {
                        display: flex;
                        margin-bottom: 7px;
                        .address_item {
                            width: 400px;
                            // margin-right: 30px;
                        }
                    }
                }

                .remark {
                    font-size: 18px;
                    color: red;
                    font-weight: bold;
                    padding-left: 120px;
                    padding-top: 20px;
                    width: 600px;
                }
            }

            .content_right {
                width: 687px;
                box-sizing: border-box;
                padding-top: 55px;
                .freight {
                    display: flex;
                    font-size: 16px;
                    color: red;
                    font-weight: bold;
                    .freight_item {
                        width: 150px;
                        padding-top: 5px;
                        box-sizing: border-box;
                        text-align: center;
                        span {
                            font-size: 18px;
                        }
                    }
                }
                .expense {
                    display: flex;
                    font-size: 16px;
                    color: red;
                    font-weight: bold;
                    padding-top: 48px;
                    .expense_item {
                        width: 200px;
                        box-sizing: border-box;
                        padding-left: 70px;
                        box-sizing: border-box;
                        margin-right: 50px;
                    }
                    .expense_item:last-child {
                        margin-right: 0;
                    }
                }

                .capital{
                    padding-top: 18px;
                    box-sizing: border-box;
                    padding-right: 82px;
                    display: flex;
                    justify-content: flex-end;
                    font-size: 16px;
                    color: red;
                    font-weight: bold;
                    .capital_item{
                        text-align: right;
                        letter-spacing:50px;
                        margin-bottom: 27px;
                    }
                    .capital_item:last-child{
                        margin-bottom: 0;
                    }

                    .capital_number{
                         margin-bottom: 24px;
                         padding-top: 5px;
                    }
                    .capital_number:last-child{
                        margin-bottom: 0;
                    }
                    .capital_left{
                        width: 400px;
                        margin-right: 60px;
                    }
                }

                .pick{
                    padding-top: 16px;
                    box-sizing: border-box;
                    padding-right: 20px;
                    font-size: 20px;
                    color: red;
                    font-weight: bold;
                    padding-left: 163px;
                }
            }
        }
    }
}
</style>